import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link to={item.to} className="transition-colors duration-200 hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700">{item.label}</span>
          )}
          {idx < items.length - 1 ? (
            <i className="ri-arrow-right-s-line text-sm text-foreground-400" aria-hidden="true" />
          ) : null}
        </span>
      ))}
    </nav>
  );
}